import { Box, styled, Typography } from "@mui/material";

export const StyledProductTitle = styled(Typography)`
  margin: 0.7rem 0;
  text-transform: uppercase;
  letter-spacing: -1px;
  font-family: Gotham-Bold;
  font-size: 1.3rem;

  @media (min-width: 600px) {
    font-size: 1.6rem;
  }
`;
export const StyledProductSubTitle = styled(Typography)``;
export const StyledCurrentlyUnAvailable = styled(Typography)`
  font-size: 1rem;
`;
export const StyledViewAllLink = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  cursor: pointer;
  height: 300px;
  width: 300px;
  background-color: ${({ theme }) => theme.palette.secondary.light};
  display: flex;
  justify-content: center;
  align-items: center;
`;
